export default {
    setContactUsStatus (state, {status}) {
        state.contactUsStatus = !status
    },
    setError (state, { error }) {
        state.error = error
    }
}



// WEBPACK FOOTER //
// ./src/store/contactus/mutations.js